import React from "react";
import "./style.css";

function Wrapper(props) {
  return <main className="Wrapper" {...props} />;
}

export default Wrapper;
